import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useAuth } from '../../auth/AuthContext';

/**
 * Componente que força verificação de autenticação
 * Mostra status e permite relogar facilmente
 */
export const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const token = localStorage.getItem('token');

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="text-muted">Verificando autenticação...</p>
        </div>
      </div>
    );
  }

  if (!token || !user) {
    return (
      <div className="container mt-5">
        <Alert variant="warning">
          <Alert.Heading>🔒 Sessão Expirada</Alert.Heading>
          <p>
            Você não está autenticado ou sua sessão expirou.
            Por favor, faça login novamente.
          </p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button 
              variant="primary" 
              onClick={() => window.location.href = '/login'}
            >
              Ir para Login
            </Button>
          </div>
        </Alert>
      </div>
    );
  }

  return <>{children}</>;
};
